<template>
    <div>
        <!--shop wrapper start-->
        <!--shop toolbar start-->
        <div class="shop_title">
            <h3>{{ title ? title : 'Danh sách sản phẩm' }}</h3>
        </div>
        <div class="shop_toolbar_wrapper">
            <div class="shop_toolbar_btn">

                <button data-role="grid_3" type="button" class=" btn-grid-3" data-bs-toggle="tooltip" title="3"></button>

                <button data-role="grid_4" type="button"  class="active btn-grid-4" data-bs-toggle="tooltip" title="4"></button>

                <button data-role="grid_list" type="button"  class="btn-list" data-bs-toggle="tooltip" title="List"></button>
            </div>
        </div>
            <!--shop toolbar end-->

        <div class="row shop_wrapper" v-if="items && items.length > 0">
            <div class="col-lg-3 col-md-4 col-6 " v-for="(item, index) in items" :key="index">
                <div class="single_product">
                    <div class="product_thumb">
                        <a class="primary_img" @click="gotoDetail(item.id)"><img :src="(!item.nhanh_id ? '/'+item.path : item.image) || '/assets/img/noimage.jpg'" alt=""></a>
                    </div>

                    <div class="product_content grid_content">
                        <div class="content_inner">
                                <div class="product_name">
                                    <h3><a @click="gotoDetail(item.id)">{{ item.name }}</a></h3>
                                </div>
                                <div class="product_code">
                                    <h3><a @click="gotoDetail(item.id)">Mã sản phầm: {{ item.product_code }}</a></h3>
                                    <h3 v-if="item.made_in">Xuất xứ: {{ item.made_in }}</h3>
                                    <h3 class="inventory">Hàng sẵn: <b>{{ item.qty | currency }}</b></h3>
                                    <div v-html="getCategories(item)"></div>
                                </div>
                                <div class="price_box">
                                    <span class="current_price">{{ (is_wholesale && item.special_price ? item.special_price : is_vip && item.vip_price ? item.vip_price : item.price) | currency }}</span>
                                </div>
                                <div class="price_box">
                                    <span class="old_price text-red">{{ !item.is_active ? 'Hết hàng' : '' }}</span>
                                </div>
                                <!-- <div class="action_links">
                                    <ul>
                                        <li class="add_to_cart"><a :href="'/chi-tiet-san-pham/' + item.id " title="add to cart"><i class="fa fa-shopping-bag"></i> Xem tuỳ chọn</a></li>
                                    </ul>
                                </div> -->
                            </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="row shop_wrapper ma-4" v-else-if="!loading">
            <h4 class="red--text">Hãy liên hệ Zalo 0969768448 để nhận tài khoản Ctv/sỉ từ Mai Chất Group</h4>
        </div>
        <div class="shop_toolbar t_bottom" v-if="total_page">
            <v-pagination v-model="current_page" :length="total_page" :total-visible="7" ></v-pagination>
            <!-- <div class="pagination">
                <ul>
                    <li><a @click="filter_data(-1)"> {{ prev }} </a></li>
                    <li><a @click="filter_data(1)"> {{ next }} </a></li>
                </ul>
            </div> -->
        </div>
        <!--shop toolbar end-->
        <!--shop wrapper end-->
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from '@/configs'
import _ from 'lodash';
export default {
    name: "product-list",
    data() {
        return {
            prev: '<<',
            next: '>>',
            current_page: 1,
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterConditions: [],
            quickFilterConditions: []
        }
    },
    props: {
        title: String,
        page_size: Number,
        list_category: Array
    },
    computed: {
        ...mapState({
            items: state => state.products.all.data,
            total_rows: state => state.products.all.total,
            loading: state => state.products.loading,
            categories: state => state.categories.all.data,
        }),
        adminRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
        },
        is_wholesale() {
            return this.$store.state.authentication.user.wholesale == 1;
        },
        is_vip() {
            return this.$store.state.authentication.user.wholesale == 2;
        },
        search_params() {
            return this.$route.query;
        },
        total_page() {
            if(this.page_size) {
                return Math.ceil(this.total_rows/this.page_size);
            }
            return Math.ceil(this.total_rows/this.pagination.itemsPerPage);
        }
    },
    watch: {
        list_category() {
            this.filter_data();
        },
        search_params() {
            this.filter_data();
        },
        current_page() {
            let params = [];
            if (this.search_params && this.search_params.s) {
                params.push(`s=${this.search_params.s}`)
            }
            params.push(`p=${this.current_page}`)
            window.getApp.$router.push(`/san-pham?${params.join('&')}`).catch(error => {
                if (error.name != "NavigationDuplicated") {
                    throw error;
                }
            });
        }
    },
    methods: {
        filter_data: function (direction = 0) {
            var param = {
                pagination: this.pagination,
                filter: [],
                quickFilter: this.quickFilterConditions
            };
            if(this.page_size) {
                param.pagination.itemsPerPage = this.page_size;
            }
            if (this.search_params && this.search_params.p) {
                this.current_page = Number(this.search_params.p);
            }
            param.pagination.page = this.current_page;

            if(this.list_category && this.list_category.length > 0) {
                param.filter.push({
                    column: "category_id",
                    value: _.map(this.list_category, 'id'),
                    condition: "in",
                });
            }
            if (this.search_params && this.search_params.s) {
                param.filter.push({
                    column: "filter_name",
                    value: this.search_params.s,
                    condition: "contain",
                });
            }
            param.filter.push({
                column: "is_active",
                value: 1,
                condition: "equal",
            });
            param.filter.push({
                column: "is_hidden",
                value: 0,
                condition: "equal",
            });
            this.$store.dispatch("products/getList", param);
            // window.scrollTo(0,0);
        },
        gotoDetail(id) {
            window.getApp.$router.push(`/chi-tiet-san-pham/${id}`);
        },
        getCategories(item) {
            if(item.categories === null || item.categories === undefined) {
                return '';
            }
            let category_ids = item.categories.split(',');
            let ret = '';
            for (let i = 0; i < category_ids.length; i++) {
                let category = this.categories.find(c => c.id == category_ids[i]);
                if (category) {
                    ret += `<a href='/san-pham?cat=${category.id}'>#${category.name}</a>`;
                }
            }
            return ret.trim();
        }
    },
    mounted() {
        this.filter_data();
        this.$store.dispatch("categories/getList");
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }

}
</script>